// extracted by mini-css-extract-plugin
module.exports = {"delay":"delay-0f953ee925fee099a993b9918d3307a8","box":"box-bfd7ab50ba83a2cfcfe36c08624fecdd","button-div":"button-div-095d52bb9c595a63807cfe44a1c7e239"};